import { Infer, enums, nullable, object, optional, string } from "superstruct";

export type CookieData = {
  formName: string;
  cookieTagName: string;
  title: string | null;
  paragraph?: string | JSX.Element | JSX.Element[];
  onLoadTracker: ({
    accepted,
    hasChanged,
  }: {
    accepted: boolean;
    hasChanged: boolean;
  }) => void;
};

export const ModCfCookieBanner = object({
  __typename: enums(["ContentfulCookieBannerV2"]),
  contentful_id: string(),
  bannerTitle: string(),
  bannerText: object({
    bannerText: string(),
  }),
  bannerBtnAccept: string(),
  bannerBtnReject: nullable(string()),
  bannerBtnManage: string(),
  modalTitle: string(),
  modalSecondTitle: string(),
  modalText: object({
    modalText: string(),
  }),
  modalBtnAcceptAll: string(),
  // TODO: remove optionality when we decomment this prop in intex.tsx
  modalBtnDenyAll: optional(nullable(string())),
  modalBtnClose: string(),
  modalBtnSubmit: string(),
  cookieTechTitle: string(),
  cookieTechText: object({
    cookieTechText: string(),
  }),
  cookieTechToggleAreaLabel: string(),
  cookieAnalysisTitle: string(),
  cookieAnalysisText: object({
    cookieAnalysisText: string(),
  }),
  cookieAnalysisToggleAreaLabel: string(),
  cookieProfilingTitle: string(),
  cookieProfilingText: object({
    cookieProfilingText: string(),
  }),
  cookieProfilingToggleAreaLabel: string(),
  trackerGoogleAnalyticsTitle: string(),
  trackerGoogleAnalyticsText: object({
    trackerGoogleAnalyticsText: string(),
  }),
  trackerABtestingTitle: string(),
  trackerABtestingText: object({
    trackerABtestingText: string(),
  }),
  trackerAdformTitle: string(),
  trackerAdformText: object({
    trackerAdformText: string(),
  }),
  trackerPixelFbTitle: nullable(string()),
  trackerPixelFbText: nullable(
    object({
      trackerPixelFbText: string(),
    }),
  ),
  trackerTwitterTitle: nullable(string()),
  trackerTwitterText: nullable(
    object({
      trackerTwitterText: string(),
    }),
  ),
  trackerLinkedinTitle: nullable(string()),
  trackerLinkedinText: nullable(
    object({
      trackerLinkedinText: string(),
    }),
  ),
  trackerBingTitle: nullable(string()),
  trackerBingText: nullable(
    object({
      trackerBingText: string(),
    }),
  ),
  trackerNielsenTitle: nullable(string()),
  trackerNielsenText: nullable(
    object({
      trackerNielsenText: string(),
    }),
  ),
  trackerTikTokTitle: nullable(string()),
  trackerTikTokText: nullable(
    object({
      trackerTikTokText: string(),
    }),
  ),
  trackerClarityTitle: nullable(string()),
  trackerClarityText: nullable(
    object({
      trackerClarityText: string(),
    }),
  ),
  trackerNewcoTitle: nullable(string()),
  trackerNewcoText: nullable(
    object({
      trackerNewcoText: string(),
    }),
  ),
  trackerPubmaticTitle: nullable(string()),
  trackerPubmaticText: nullable(
    object({
      trackerPubmaticText: string(),
    }),
  ),
  trackerWeboramaTitle: nullable(string()),
  trackerWeboramaText: nullable(
    object({
      trackerWeboramaText: string(),
    }),
  ),
});

export type CfCookieBanner = Infer<typeof ModCfCookieBanner>;
